<template>
  <div class="container">
    <PublicHeader :totalName="$t('Withdrawal').title" />
    <div class="top box">
      <div v-if="userInfo.IsBindBank">
        <div v-if="basicConfig.IsBank" class="line">
          <span>{{ $t('Withdrawal').cardNo }}</span>
          <span>{{ showBankCard(userInfo.CardNo) }}</span>
        </div>
        <div v-else class="line">
          <span>SWIFTCode</span>
          <span>{{ showBankCard(userInfo.SWIFTCode) }}</span>
        </div>
      </div>

      <router-link
        tag="div"
        :to="{ name: bindRouter }"
        class="line unBank"
        v-else
      >
        <span>{{
          basicConfig.IsBank
            ? $t('Withdrawal').unBind
            : $t('Withdrawal').unSWIFTCode
        }}</span>
        <van-icon name="debit-pay" size="20" style="margin-left: 8px" />
      </router-link>
      <div v-if="basicConfig.IsShowCurrency">
        <div class="line" v-if="userInfo.USDT">
          <span>USDT</span>
          <span>{{ userInfo.USDT }}</span>
        </div>
        <div class="line" v-if="userInfo.BTC">
          <span>BTC</span>
          <span>{{ userInfo.BTC }}</span>
        </div>
        <div class="line" v-if="userInfo.ETH">
          <span>ETH</span>
          <span>{{ userInfo.ETH }}</span>
        </div>
      </div>

      <div class="line noBottomLine">
        <span>{{ $t('Withdrawal').AccountBalance }}</span>
        <span>{{ basicConfig.Symbol }}{{ userInfo.Balance }}</span>
      </div>
      <div v-if="basicConfig.IsFrozen">
        <div class="line">
          <span>{{ $t('Withdrawal').cashBalance }}</span>
          <span>{{ basicConfig.Symbol }}{{ userInfo.CashAmount }}</span>
        </div>
        <p class="info" v-if="userInfo.FrozenAmount > 0">
          {{ $t('Withdrawal').RrozenAmount }}：{{ basicConfig.Symbol }}
          {{ userInfo.FrozenAmount }}
        </p>
      </div>

      <div v-if="basicConfig.IsCashRealName">
        <div class="line" v-if="!userInfo.IsReal">
          <span>{{ $t('Withdrawal').PRNA }}</span>
          <router-link tag="span" to="Authentication" class="authentication">{{
            $t('Withdrawal').RNA
          }}</router-link>
        </div>
        <div v-else>
          <div class="line">
            <span>{{ $t('Withdrawal').RealName }}</span>
            <span>{{ userInfo.RealName }}</span>
          </div>
          <div class="line">
            <span>{{ $t('Withdrawal').mobile }}</span>
            <span>***********</span>
          </div>
          <div class="line">
            <span>{{ $t('Withdrawal').IDNumber }}</span>
            <span>***********</span>
          </div>
          <div class="line">
            <span>{{ $t('Withdrawal').CertificateAddress }}</span>
            <span>***********</span>
          </div>
          <div class="line">
            <span>{{ $t('Withdrawal').CurrentAddress }}</span>
            <span>***********</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom box">
      <div class="method">
        <div class="method-title">提现方式</div>
        <van-radio-group v-model="form.TransferType" direction="horizontal">
          <van-radio name="Bank">{{ basicConfig.IsBank ? '银行卡' : 'SWIFT Code' }}</van-radio>
          <template v-if="basicConfig.IsWeChatAlipayWithdrawal">
            <van-radio name="WeChat">微信</van-radio>
            <van-radio name="Alipay">支付宝</van-radio>
          </template>
          <template v-if="basicConfig.IsShowCurrency">
            <van-radio name="USDT">USDT</van-radio>
            <van-radio name="BTC">BTC</van-radio>
            <van-radio name="ETH">ETH</van-radio>
          </template>
        </van-radio-group>
        <router-link
          v-if="needsPaymentBinding"
          class="bind-tip"
          :to="{ name: 'PaymentAccount', query: { type: form.TransferType } }"
        >请先绑定{{ form.TransferType === 'WeChat' ? '微信' : '支付宝' }}收款码</router-link>
      </div>
      <div class="money">
        <div class="line">
          <span>{{ $t('Withdrawal').WithdrawAmount }}</span>
          <van-field
            v-model="form.Amount"
            input-align="right"
            @input="handleChange"
            :placeholder="placeholder"
          />
        </div>
        <p>
          <!-- {{ $t('Withdrawal').placeholder1 }}{{ userInfo.Charge }}
          {{ $t('Withdrawal').placeholder2 }}
          {{ basicConfig.Symbol
          }}{{ ((userInfo.Charge / 100) * form.Amount).toFixed(2) }} -->
          {{ $t('Withdrawal').CommissionText }} {{ basicConfig.Symbol
          }}{{ realAmount.toFixed(2) }}
        </p>
      </div>
      <div class="line">
        <span>{{ $t('Withdrawal').WithdrawPassword }}</span>
        <van-field
          v-model="form.CashPassword"
          type="password"
          input-align="right"
          :placeholder="$t('Withdrawal').placeholder"
        />
      </div>
    </div>
    <div class="bigBtn" @click="handleSubmit">
      {{ $t('Withdrawal').Submit }}
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import userApi from '@/api/user'
import transactionApi from '@/api/transaction'
import { mapGetters } from 'vuex'
export default {
  components: {
    PublicHeader,
  },
  data() {
    return {
      userInfo: {},
      placeholder: '',
      realAmount: 0,
      form: {
        CashPassword: null,
        IsUpper: false,
        Amount: null,
        TransferType: 'Bank',
      },
    }
  },
  computed: {
    ...mapGetters(['basicConfig']),
    bindRouter() {
      return this.basicConfig.IsBank ? 'Bank' : 'SWIFTCode'
    },
    needsPaymentBinding() {
      if (this.form.TransferType === 'WeChat') return !this.userInfo.WeChatQrCode
      if (this.form.TransferType === 'Alipay') return !this.userInfo.AlipayQrCode
      return false
    },
  },
  methods: {
    handleChange() {
      let form = this.form
      form.Amount = form.Amount.replace(/[^\d.]/g, '')
      if (this.timer) {
        clearTimeout(this.timer)
        this.getCharge()
      } else {
        this.getCharge()
      }
    },
    getCharge() {
      this.timer = setTimeout(async () => {
        if (Number(this.userInfo.Balance) >= Number(this.form.Amount)) {
          const res = await transactionApi.charge({
            Amount: Number(this.form.Amount),
          })
          this.realAmount = this.form.Amount - res
        } else {
          this.realAmount = 0
        }
      }, 1000)
    },
    async getUserInfo() {
      let res = await userApi.userInfo()
      this.userInfo = res
      if (!this.basicConfig.IsBank && this.form.TransferType === 'Bank') {
        this.form.TransferType = 'SWIFTCode'
      }
      this.placeholder =
        this.basicConfig.Symbol +
        res.CashLowLimit +
        ' - ' +
        this.basicConfig.Symbol +
        res.CashTopLimit
      if (!res.IsCashPassword) {
        this.$dialog
          .confirm({
            title: this.$t('Withdrawal').tips,
            message: this.$t('Withdrawal').tipsMessage,
          })
          .then(() => {
            this.$router.push({ name: 'EditWithPassword' })
          })
          .catch(() => {
            this.$router.go(-1)
          })
      }
    },
    showMobile(PhoneNumber) {
      return PhoneNumber.substr(0, 3) + '****' + PhoneNumber.substr(8)
    },
    showIdCard(IdCard) {
      return IdCard.substr(0, 5) + '*********' + IdCard.substr(-4)
    },
    showBankCard(CardNo) {
      return '**** **** **** ' + CardNo.substr(-4)
    },
    async handleSubmit() {
      let form = { ...this.form }
      if (this.needsPaymentBinding) {
        this.$router.push({ name: 'PaymentAccount', query: { type: form.TransferType } })
        return
      }
      if (form.Amount === '') {
        this.$toast({
          message: this.$t('Withdrawal').AmountMessage,
          position: 'bottom',
        })
        return
      }
      // if (form.CashPassword.length < 6) {
      //   this.$toast({
      //     message: this.$t('Withdrawal').PassMessage,
      //     position: 'bottom',
      //   })
      //   return
      // }
      form.Amount = Number(form.Amount)
      await transactionApi.TransferRecords(form)
      this.$toast.success(this.$t('public').SubmittedSuccessfully)
      if (this.basicConfig.IsCashToService) {
        this.$router.push({
          name: 'WithService',
          params: { Amount: form.Amount },
        })
      } else {
        this.$router.go(-1)
      }
    },
  },
  mounted() {
    this.getUserInfo()
  },
}
</script>

<style lang="stylus" scoped>
@import "~@/styles/mixin.styl";
.container
  width: 100%;
  background-color #1f1f1f
  font-size: 14px;
  color #ebe5cd
  overflow-x hidden
  height 100vh
  padding-top 48.5px
  .info
    text-align right
    color #e8d49e
    height 21px
    font-size 12px
    padding-right 10px
  .box
    border-radius 5px
    border 1Px solid #40404b
    margin 15px 14px
    .line
      height 40px
      width 100%
      flex-between()
      padding 0 10px
      border-bottom 1Px solid #40404b
      span:nth-of-type(2)
        color #fff
      .authentication
        text-decoration underline
    .noBottomLine
      border-bottom none
    .unBank
      justify-content flex-start
  .bottom
    .method
      padding 12px 10px
      border-bottom 1Px solid #40404b
      .method-title
        margin-bottom 12px
      >>> .van-radio
        margin 0 16px 10px 0
      >>> .van-radio__label
        color #fff
      >>> .van-radio__icon--checked .van-icon
        background #d6b372
        border-color #d6b372
      .bind-tip
        display block
        color #e8d49e
        margin-top 4px
    .line
      border-bottom none
      .van-field
        width 50%
        background none
        padding 0
        >>> .van-field__control
          color #fff
        >>> input::-webkit-input-placeholder
          color #969799
    .money
      border-bottom 1Px solid #40404b
      p
        text-align right
        color #e8d49e
        height 21px
        font-size 12px
        padding-right 10px
  .bigBtn
    width: 92%
    height 40px
    flex-center()
    color #222222
    font-size: 15px
    background: linear-gradient(315deg,#e8d49e,#d6b372)!important;
    margin 40px auto
    border-radius: 5px
</style>
